
import { Hero } from "@/components/sections/Hero";
import { QuickApply } from "@/components/sections/QuickApply";
import { ServicesGrid } from "@/components/sections/ServicesGrid";
import { EMIWidget } from "@/components/sections/EMIWidget";
import { SuccessStories } from "@/components/sections/SuccessStories";
import { PartnerBanks } from "@/components/sections/PartnerBanks";
import { FloatingButtons } from "@/components/common/FloatingButtons";

const Index = () => {
  return (
    <div className="w-full">
      <Hero />
      <QuickApply />
      <ServicesGrid />
      <EMIWidget />
      <PartnerBanks />
      <SuccessStories />
      <FloatingButtons />
    </div>
  );
};

export default Index;
